/* bf26y-r12.js (13 Oct 2026, r12; r13 and r15 additions marked). Theme-only fixes loaded last from snippets/bf26a-a11y.liquid. Rollback: delete the two r12 lines there.
   1 ladderCopy: wash-bag and mystery-gift product pages say what unlocks them instead of an item count
   2 add buttons in quick view dialogs go busy (disabled + spinner) briefly so a double tap cannot add twice
   3 /pages/rkkn-set add stamps _bf_set and _bf_bundle on the lines, like every other set route
   4 set panels (What is inside) list the free wash bag; set price blocks show the saving; Starter Set colour copy
   5 tap target hit areas >= 44px (invisible ::after) for small buttons and links
   r13: 6 mystery gift auto-add  7 'Unavailable' shown as 'Sold out'  8 /pages/gift-sets links go to /pages/sets, Track Order link removed, /pages/contact goes to /pages/contact-us  9 cream newsletter band on blog and 404  10 sock PDP empty complementary recommendations block removed (saves a 589KB section fetch)
   r53 (15 Oct 2026): 6 moved to bf26y-giftguard.js (one cart sync); 4 'Save X' uses the shopper's currency.
   r15: the gift now follows the ladder bar count (pieces plus the free wash bag, gift line excluded): added at 7 items, removed again below 7 when it was auto-added. Backup: bf26y-r12-bak-20261013-r15.js */
(function () {
  function rkLazy(fn, own) { var go = function () { if (window.BF26 && BF26.lazy) BF26.lazy(fn); else own(); }; if ((window.BF26 && BF26.lazy) || document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go); } /* 21 Oct 2026: shared sweep in bf26-core.js */
  var path = location.pathname;
  function ready(f) { if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }
  /* r53: the saving is formatted in the shopper's currency (window.bf26Money from snippets/bf26-money.liquid = the market's own money format), never a typed "$" */
  function money(n) {
    var cents = Math.round(n * 100);
    if (window.bf26Money) return window.bf26Money(cents);
    var iso = (window.BF26_CURRENCY && window.BF26_CURRENCY.iso) || (window.Shopify && Shopify.currency && Shopify.currency.active);
    try { if (iso) return new Intl.NumberFormat(undefined, { style: 'currency', currency: iso, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); } catch (e) {}
    return (cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100));
  }
  // "1,234.50", "1.234,50", "26,95 EUR" -> number (a comma or dot followed by exactly 2 digits at the end is the decimal mark)
  function num(s) {
    var m = String(s).match(/\d[\d.,\s]*/); if (!m) return 0;
    var t = m[0].replace(/\s/g, ''), d = /[.,](\d{2})$/.exec(t);
    return d ? parseFloat(t.slice(0, -3).replace(/[.,]/g, '') + '.' + d[1]) : parseFloat(t.replace(/[.,]/g, '')) || 0;
  }
  function saveLine(after, d) {
    var ex = after.parentNode && after.parentNode.querySelector('.bf26y-save');
    if (d < 1) { if (ex) ex.remove(); return; }
    var t = 'Save ' + money(d);
    if (ex) { if (ex.textContent !== t) ex.textContent = t; return; }
    var p = document.createElement('p'); p.className = 'bf26y-save'; p.textContent = t;
    after.parentNode.insertBefore(p, after.nextSibling);
  }

  if (/^\/pages\/rkkn-set\/?$/.test(path) && !window.__bf26yR12Fetch) {
    window.__bf26yR12Fetch = 1;
    var of = window.fetch;
    window.fetch = function (u, o) {
      try {
        var url = String(u && u.url || u);
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && o && typeof o.body === 'string' && o.body.charAt(0) === '{') {
          var b = JSON.parse(o.body);
          if (b.items && b.items.length >= 4) {
            b.items.forEach(function (i) { i.properties = Object.assign({ _bf_set: 'RꓘKN Set', _bf_bundle: '1' }, i.properties || {}); });
            o = Object.assign({}, o, { body: JSON.stringify(b) });
          }
        }
      } catch (e) {}
      return of.call(this, u, o);
    };
  }

  var handle = (path.match(/^\/products\/([^\/]+)/) || [])[1];
  var COPY = { 'wash-bag': 'Free with 3 or more pieces in your order.', 'mystery-gift': 'Free with 7 or more pieces in your order.' }; /* r55 FX4 (Q2-28): mix and match is only the Bundle Builder (DESIGN 9.3) */
  function ladderCopy() {
    var t = COPY[handle]; if (!t) return;
    document.querySelectorAll('.bfp__nudge').forEach(function (n) {
      var c = n.querySelector('[data-bfp-count]'), m = n.querySelector('[data-bfp-msg]');
      if (c && c.style.display !== 'none') c.style.display = 'none';
      if (m && m.textContent !== t) m.textContent = t;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button');
    if (!b || (!/^\s*add\b/i.test(b.textContent) && !b.classList.contains('quick-add__submit'))) return;
    if (!b.closest('[role="dialog"], quick-add-modal, [class*="qv"]')) return;
    setTimeout(function () {
      if (b.hasAttribute('data-bf26y-busy')) return;
      b.setAttribute('data-bf26y-busy', '1'); b.setAttribute('aria-busy', 'true');
      var was = b.disabled; b.disabled = true;
      setTimeout(function () { b.removeAttribute('data-bf26y-busy'); b.removeAttribute('aria-busy'); b.disabled = was; }, 1600);
    }, 0);
  }, false);

  function panels() {
    document.querySelectorAll('.bf26s-panel').forEach(function (p) {
      var s = p.querySelector('script[data-bf26s]'), ul = p.querySelector('.bf26s-panel__list'); if (!s || !ul) return;
      var c; try { c = JSON.parse(s.textContent); } catch (e) { return; }
      var has = /wash/i.test(ul.textContent);
      var wants = (c.items || []).some(function (i) { return i.handle === 'wash-bag'; }) || /3-Pack (Glove )?Set$/.test(c.title || '');
      if (wants && !has) {
        var li = document.createElement('li'); li.innerHTML = '<span>+free wash bag</span>'; /* r54: the one wash bag wording (DESIGN 9.6) */ ul.appendChild(li);
      }
    });
    document.querySelectorAll('.bf26s-panel__price').forEach(function (pp) {
      var s = pp.querySelector('s'); if (s) saveLine(pp, num(s.textContent) - num(pp.firstChild && pp.firstChild.textContent));
    });
    /* r55 FX4 (N7, Q2-08): the RKKN Set product page no longer gets a "Save £X" line after load. The price block already shows the set price
       next to the struck retail price (server-rendered, snippets/price.liquid), like the other set pages, so the extra line was a second cue that appeared late. */
    if (handle === 'starter-set' && document.querySelector('.color-swatch__label') && /Ros/.test(document.body.textContent)) {
      var w = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (n.nodeValue.indexOf('Oat, White or Black') > -1) n.nodeValue = n.nodeValue.replace('Oat, White or Black', 'Oat, White, Black or Rosé'); }
    }
  }

  var SEL = 'a[href], button, [role="button"], summary';
  /* 25 Oct 2026 (speed): two passes. Pass 1 only reads (rects, styles), pass 2 only writes, so the browser lays the page out once instead
     of once per link (it was ~0.5 s on a phone). Runs in idle time: it only enlarges small tap targets, nothing visible changes. */
  var hitQ = false;
  function hit() {
    if (hitQ) return; hitQ = true;
    (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(function () { hitQ = false; hitNow(); }, { timeout: 2000 });
  }
  function hitNow() {
    var els = document.querySelectorAll(SEL), i, e, r, st, todo = [];
    for (i = 0; i < els.length; i++) {
      e = els[i]; if (e.hasAttribute('data-bf26y-hit')) continue;
      r = e.getBoundingClientRect(); if (!r.width || !r.height) continue;
      if (r.width >= 44 && r.height >= 44) { todo.push([e, 0]); continue; }
      st = getComputedStyle(e); if (st.visibility === 'hidden' || st.display === 'none') continue;
      if (getComputedStyle(e, '::after').content !== 'none') { todo.push([e, 0]); continue; }
      todo.push([e, 1, Math.max(0, 44 - r.width) / 2, Math.max(0, 44 - r.height) / 2, st.position === 'static']);
    }
    for (i = 0; i < todo.length; i++) {
      var t = todo[i]; e = t[0];
      e.setAttribute('data-bf26y-hit', t[1] ? '1' : '0');
      if (!t[1]) continue;
      e.style.setProperty('--bf26y-hx', t[2] + 'px'); e.style.setProperty('--bf26y-hy', t[3] + 'px');
      if (t[4]) e.style.position = 'relative';
    }
  }

  var SO = 'button, option, label, legend, .badge, variant-selects, variant-radios, fieldset, .product-form, .card__information, [class*="sticky"], [class*="swatch"]';
  function soldOut() {
    document.querySelectorAll(SO).forEach(function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, v;
      while ((n = w.nextNode())) {
        v = n.nodeValue;
        if (v.length > 90 || v.indexOf('Unavailable') < 0) continue;
        n.nodeValue = v.replace(/\s*-\s*Sold Out\s*-\s*Unavailable/i, ' - Sold out').replace(/Unavailable/g, 'Sold out');
      }
    });
  }

  function links() {
    document.querySelectorAll('a[href*="/pages/gift-sets"]').forEach(function (a) { a.setAttribute('href', a.getAttribute('href').replace('/pages/gift-sets', '/pages/sets')); });
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (/^track\s*(my\s*)?order/i.test(a.textContent.trim())) { (a.closest('li') || a).remove(); }
    });
    document.querySelectorAll('a[href="/pages/contact"]').forEach(function (a) { a.setAttribute('href', '/pages/contact-us'); });
  }

  function cream() {
    if (!/^\/blogs\//.test(path) && !/404|not found/i.test(document.title)) return;
    document.querySelectorAll('.newsletter__wrapper:not(.bf26y-cream)').forEach(function (w) { w.classList.add('bf26y-cream'); });
  }

  /* r53 (15 Oct 2026): the mystery gift auto-add (r13 / r15) moved to assets/bf26y-giftguard.js, the one cart sync for the free bag and gift (paid pieces only,
     no page reload on /cart, guarded against retry loops). */

  var t;
  function all() { try { panels(); hit(); soldOut(); links(); cream(); } catch (e) {} } /* 21 Oct 2026: ladderCopy() off, no product page has the .bfp ladder it rewrote */
  function sched() { clearTimeout(t); t = setTimeout(all, 150); }
  ready(function () {
    if (handle === 'softgrip-scrunch-socks') document.querySelectorAll('product-recommendations.complementary-products').forEach(function (n) { n.remove(); });
    all(); rkLazy(all, function () { new MutationObserver(sched).observe(document.body, { childList: true, subtree: true }); window.addEventListener('resize', sched); });
  });
})();
